<template>
  <div class="customer-holder">

    <h1>{{ t.login_and_registration }}</h1>

    <div id="webshop-customer-block" class="webshop-customer-block">

      <div class="row">
        <div class="col-md-6 webshop-customer-left">
          <h2>{{ t.returning_customer }}</h2>

          <form method="post" id="webshop-customer-login" v-on:submit.prevent>

            <div class="form-group">
              <label class="control-label" for="email">{{ t.email }}</label>
              <input type="text" id="email" class="form-control" name="email"
                     v-model="userData.email"
                     v-bind:class="{ 'is-invalid' : error.customerLogin }"
                     @focus="error.customerLogin = null">

            </div>

            <div class="form-group">
              <label class="control-label" for="password">{{ t.password }}</label>
              <input type="password" id="password" class="form-control" name="password"
                     v-model="userData.password"
                     v-bind:class="{ 'is-invalid' : error.customerLogin }"
                     @focus="error.customerLogin = null">

              <p class="input-error-hint" v-if="error.customerLogin">{{ error.customerLogin }}</p>

            </div>

            <div class="custom-control custom-checkbox">
              <input type="checkbox" id="remember-me" class="custom-control-input" name="remember-me" v-model="userData.rememberMe">
              <label class="custom-control-label" for="remember-me">{{ t.remember_me }}</label>
            </div>

            <div class="webshop-customer-buttons">

              <div class="customer-button">
                <a href="/site/request-password-reset" class="btn btn-default">{{ t.forgot_password }}</a>
              </div>

              <div class="customer-button">
                <button class="btn btn-primary" v-on:click="loginUser">{{ t.sign_in }}</button>
              </div>

            </div>

          </form>

        </div>

        <div class="col-md-6 webshop-customer-right">
          <h2>{{ t.new_customer }}</h2>

          <router-link :to="{ path: '/webshop/step/customer-form', query: { type: '1' }}" class="btn btn-secondary" style="margin-right: 10px;">{{ t.registration }}</router-link>

          <router-link :to="{ path: '/webshop/step/customer-form', query: { type: '2' }}" class="btn btn-secondary">{{ t.without_registration }}</router-link>

        </div>
      </div>
    </div>

    <div class="webshop-step-holder" style="margin-top: 30px;">

      <div class="webshop-step-left">

        <div class="step-button">
          <router-link :to="{ name: 'Cart' }" class="btn btn-secondary">
            <i class="fa fa-arrow-left" aria-hidden="true"></i> {{ t.back }}
          </router-link>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'Customer',
  computed: {
    ...mapGetters({
      t: "getLanguageData",
      error: "getErrorData",
      userData: "getUserData",
      productData: "getProductData",
    }),
  },
  methods:{
    /**
     * Felhasználó bejelentkeztetése
     */
    loginUser: function (){
      let $this = this;

      let formData = {
        'page'     : 'Customer',
        'method'   : 'LoginUser',
        'userData' : $this.userData
      };

      $this.$store.dispatch('setData', formData);
    }
  },
  created() {
    /** Ha üres a KOSÁR, akkor Cart-ra dobom! */
    if(!this.productData.products_count){
      this.$router.push({ name: 'Cart' });
      return;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });

    /** Ha van LOGIN, akkor CustomerForm-ra dobom! */
    if(this.userData.user_is_logged){
      this.$router.push({ name: 'CustomerForm' });
      return;
    }

    this.$store.commit("setCurrentStep", 'Customer');
  },
  updated() {
    /** Ha történt LOGIN újratöltöm (TOKEN miatt) */
    if(this.userData.user_is_logged){
      location.reload();
    }
  }
}
</script>